import { render } from "./TheSideBar.vue?vue&type=template&id=2aabe778&scoped=true&ts=true"
import script from "./TheSideBar.vue?vue&type=script&lang=ts"
export * from "./TheSideBar.vue?vue&type=script&lang=ts"

import "./TheSideBar.vue?vue&type=style&index=0&id=2aabe778&scoped=true&lang=css"

import exportComponent from "/container/procurement-dev.jd.net.nz/application/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aabe778"]])

export default __exports__